import {PlatformRoute} from "@tracabois/template";
import {SettingsView} from "./view/SettingsView";

export const SettingsRoutes: PlatformRoute[] = [
    {
        path: "/settings",
        components: <SettingsView />
    }
]
